import { Command } from 'ckeditor5'

import { CustomEventName } from '../../types/events'

export default class InsertImportNotesTemplateCommand extends Command {
  execute() {
    const event = new CustomEvent(CustomEventName.ADD_NOTES_TEMPLATE, {
      detail: {
        open: true,
        editor: this.editor,
      },
    })

    window.dispatchEvent(event)
  }
}
